export const en = {
    'empty-priority': 'Not specified',
    title: 'Edit the autobudget priority'
};
